import React from 'react';
import { useDispatch } from 'react-redux';
import { SegmentedControl } from '../../../CommonComponents/OPL/SegmentedControl/SegmentedControl';
import { RangePreset, useRangePresets } from '../../hooks/useRangePresets';
import { PerformancePeriodDTO } from '../../types';
import { dateToISO8601, iso8601ToDate } from '../../helpers/dates';
import { usePeriod } from '../../hooks/usePeriod';
import { setPeriod } from '../../state/actions';

const PERIODS = [
  PerformancePeriodDTO.YTD,
  PerformancePeriodDTO.QTD,
  PerformancePeriodDTO.PreviousOneYear,
  PerformancePeriodDTO.OneYear,
  PerformancePeriodDTO.ThreeYears,
  PerformancePeriodDTO.FiveYears,
  PerformancePeriodDTO.AllTime,
];

export const PERIOD_LABELS = {
  [PerformancePeriodDTO.YTD]: 'YTD',
  [PerformancePeriodDTO.QTD]: 'QTD',
  [PerformancePeriodDTO.PreviousOneYear]: `${new Date().getFullYear() - 1}`,
  [PerformancePeriodDTO.OneYear]: '1Y',
  [PerformancePeriodDTO.ThreeYears]: '3Y',
  [PerformancePeriodDTO.FiveYears]: '5Y',
  [PerformancePeriodDTO.AllTime]: 'All',
};

export const PeriodSegmentedControl = () => {
  const rangePresets = useRangePresets();

  const period = usePeriod();

  const dispatch = useDispatch();

  const rangePresetsWithDates = PERIODS.reduce((acc, _period) => {
    const preset = rangePresets.find(({ value }) => value === _period);

    if (preset) {
      acc.push(preset);
    }

    return acc;
  }, [] as RangePreset[]).map(preset => ({
    ...preset,
    dates: preset.dates.map(date => iso8601ToDate(date)),
  }));

  return (
    <SegmentedControl
      id="performance--date-range--sc"
      values={rangePresetsWithDates.map(({ value }) => PERIOD_LABELS[value])}
      selectedIndex={rangePresetsWithDates.findIndex(({ value }) => value === period.value)}
      onChange={selectedIndex => {
        const selectedRange = rangePresetsWithDates[selectedIndex];
        dispatch(
          setPeriod({
            ...selectedRange,
            dates: selectedRange.dates.map(date => dateToISO8601(date)),
          }),
        );
      }}
      ariaLabel="Select date range"
    />
  );
};
